import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { IconButton } from "@material-tailwind/react";
import { useMaterialTailwindController, setOpenSidenav } from "context/LayoutContext";

export function Sidenav({ brandImg, brandName, routes }) {
  const [controller, dispatch] = useMaterialTailwindController();
  const { sidenavType, openSidenav } = controller;
  const sidenavTypes = {
    dark: "bg-[#041c2c]",
    white: "bg-white shadow-lg",
    transparent: "bg-transparent",
  };

  return (
    <aside
      className={`${sidenavTypes[sidenavType]} ${
        openSidenav ? "translate-x-0" : "-translate-x-80"
      } fixed inset-0 z-50 my-4 ml-4 h-[calc(100vh-32px)] w-72 transition-transform duration-300 xl:translate-x-0 font-sans`}
    >
      <div
        className={`relative border-b ${
          sidenavType === "dark" ? "border-white/20" : "border-blue-gray-50"
        }`}
      >
        <Link to="/" className="flex items-center justify-center py-10 px-4">
          <img src={brandImg} alt={brandName} className="h-[10.5rem] w-auto" />
        </Link>
        <IconButton
          variant="text"
          color="white"
          size="sm"
          ripple={false}
          className="absolute right-0 top-0 grid xl:hidden"
          onClick={() => setOpenSidenav(dispatch, false)}
        >
          <XMarkIcon strokeWidth={2.5} className="h-5 w-5 text-white" />
        </IconButton>
      </div>
      <div className="m-4">
        {routes.map(({ layout, title, pages }, key) => (
          <ul key={key} className="mb-4 flex flex-col gap-1">
            {title && (
              <li className="mx-3.5 mt-4 mb-2">
                <span
                  className={`text-xs font-medium tracking-widest uppercase opacity-75 ${
                    sidenavType === "dark" ? "text-white" : "text-gray-600"
                  }`}
                >
                  {title}
                </span>
              </li>
            )}
            {pages.filter(page => !page.hidden).map(({ icon, name, path }) => (
              <li key={name}>
                <NavLink to={`/${layout}${path}`}>
                  {({ isActive }) => (
                    <div
                      className={`flex items-center gap-4 px-4 py-2 cursor-pointer transition-colors ${
                        isActive
                          ? "text-lma-gold"
                          : sidenavType === "dark"
                          ? "text-white hover:text-lma-gold"
                          : "text-gray-700 hover:text-lma-gold"
                      }`}
                    >
                      {icon}
                      <span className="text-sm font-normal tracking-widest uppercase">
                        {name}
                      </span>
                    </div>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </aside>
  );
}

Sidenav.defaultProps = {
  brandImg: "/Lone-Mountain-logo.svg",
  brandName: "Lone Mountain Aircraft",
};

Sidenav.propTypes = {
  brandImg: PropTypes.string,
  brandName: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

Sidenav.displayName = "/src/widgets/layout/sidnav.jsx";

export default Sidenav;
